import {requestProduct, requestUser, requestBase} from '@/utils/request'

export function getSkuVATPrice(data) {
  return requestBase({
    url: '/manager/product/productCategory/getSkuVATPrice',
    method: 'post',
    data
  })
}
export function warehouseGetWarehouse(data) {
  return requestProduct({
    url: '/shop/warehouse/getWarehouse',
    method: 'post',
    data
  })
}
// 店铺商品列表
export function fetchList(data) {
  return requestProduct({
    url: '/seller/shop/product/pageList',
    method: 'post',
    data
  })
}

// 我的商品列表
export function getProductList(data) {
  return requestProduct({
    url: '/seller/shop/product/productPageList',
    method: 'post',
    data
  })
}

// 获取审核中和审核驳货的数量
export function getAuditCount(data) {
  return requestProduct({
    url: '/seller/shop/product/getAuditCount',
    method: 'post',
    data
  })
}

// 店铺商品上架
export function productUpper(data) {
  return requestProduct({
    url: `/seller/shop/product/upper`,
    method: 'post',
    data
  })
}

// 店铺商品下架
export function productDown(data) {
  return requestProduct({
    url: `/seller/shop/product/under/product`,
    method: 'post',
    data
  })
}

export function fetchSimpleList(params) {
  return requestUser({
    url: '/product/simpleList',
    method: 'get',
    params: params
  })
}

// 获取国家编码
export function getCountryList() {
  return requestBase({
    url: `/product/country/listAll`,
    method: 'post',
  })
}

// 下架当前用户的所有商品
export function underAllProduct() {
  return requestProduct({
    url: `/seller/shop/product/underAllProduct`,
    method: 'post',
  })
}

// 第一步 保存spu信息
export function saveSpuInfo(data) {
  return requestProduct({
    url: `/seller/shop/product/saveSpuBaseInfo`,
    method: 'post',
    data
  })
}

// 第二步 保存sku信息
export function saveSkuInfo(data) {
  return requestProduct({
    url: `/seller/shop/product/saveSku`,
    method: 'post',
    data
  })
}

// 保存商品
export function saveProduct(data) {
  return requestProduct({
    url: `/seller/shop/product/pushProduct`,
    method: 'post',
    data
  })
}

// 保存草稿
export function saveDraft(data) {
  return requestProduct({
    url: `/seller/shop/product/newSaveDraft`,
    method: 'post',
    data
  })
}

// 根据商品ID获取快照信息  审核通过
export function getSnapshotByProductId(data) {
  return requestProduct({
    url: `/seller/shop/product/newGetSnapshotByProductId`,
    method: 'post',
    data
  })
}

// 根据快照ID获取快照  草稿 待审核 审核驳回
export function getSnapshotById(data) {
  return requestProduct({
    url: `/seller/shop/product/newGetSnapshotById`,
    method: 'post',
    data
  })
}

/**
 * 只读情况下调用
 * @param data
 */
// 获取商品详情  审核通过
export function getApproved(data) {
  return requestProduct({
    url: `/manage/product/product/newGetProductInfoById`,
    method: 'post',
    data
  })
}

// 获取商品详情  待审核 审核驳回
export function getPendingOrRejected(data) {
  return requestProduct({
    url: `/manage/product/product/newGetSnapshotProductById`,
    method: 'post',
    data
  })
}


// 获取批量新增商品的模版
export function getProductSample(data) {
  return requestProduct({
    url: `/manage/product/product/getProductTemplate`,
    method: 'post',
    responseType: "blob", //blob流
    data
  })
}

// 批量导入商品模版
export function batchSaveProduct(data) {
  return requestProduct({
    url: `/manage/product/product/batchSaveProduct`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data;'
    },
    data
  })
}

// 根据商品分类ID获取规格
export function getSpecByCategoryId(data) {
  return requestBase({
    url: `/product/specification/getSpecByCategoryId`,
    method: 'post',
    data
  })
}



// 根据商品分类ID获取规格
export function getIsAudit(data) {
  return requestProduct({
    url: `/seller/shop/product/getIsAudit`,
    method: 'post',
    data
  })
}

// 搜索模板 关键字提醒
export function keyRemind(data) {
  return requestProduct({
    url: '/buyer/product/product/keyRemind',
    method: 'post',
    data
  })
}

// 搜索模板 关键字提醒
export function getBatchTaskList(data) {
  return requestProduct({
    url: '/batchImportTask/getBatchTaskList',
    method: 'post',
    data
  })
}

//删除商品
export function deleteProductById(data) {
  return requestProduct({
    url: "/seller/shop/product/delProductById",
    method: "post",
    data,
  });
}

// 获取当前货架下未下架商品的数量
export function getShipperProductCount() {
  return requestProduct({
    url: "/seller/shop/product/getShipperProductCount",
    method: "post"
  });
}






// WEBPACK FOOTER //
// ./src/api/product.js